import { Routes } from '@angular/router';

// constants
import { Features } from '@sideline/sideline-apps-shared';

// guards
import { AuthRoleGuard } from '@sideline/sideline-apps-shared';

// components
import { LandingPage } from './features/landing/pages/landing-page/landing-page';
import { NotAllowedPage } from './features/not-allowed/pages/not-allowed-page/not-allowed-page';
import { NotFoundPage } from './features/not-found/pages/not-found-page/not-found-page';

export const routes: Routes = [

  // ==========================================================================================================================
  //  public routes
  // ==========================================================================================================================

  {
    path: '',
    component: LandingPage
  },
  {
    path: 'contact',
    loadChildren: () => import('./features/contact/contact-routing').then((m) => m.routes),
  },
  {
    path: 'not-allowed',
    component: NotAllowedPage
  },
  {
    path: 'not-found',
    component: NotFoundPage
  },

  // ==========================================================================================================================
  //  protected routes
  // ==========================================================================================================================

  {
    path: 'account',
    loadChildren: () => import('./features/account/account-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.account.symbol,
      roles: Features.account.roles.user,
    },
  },
  {
    path: 'contacts',
    loadChildren: () => import('./features/contact-manager/contacts-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.contactManager.symbol,
      roles: Features.contactManager.roles.user,
    },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.dashboard.symbol,
      roles: Features.dashboard.roles.user,
    },
  },
  {
    path: 'events',
    loadChildren: () => import('./features/event-manager/events-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.eventManager.symbol,
      roles: Features.eventManager.roles.user,
    },
  },
  {
    path: 'reservations',
    loadChildren: () => import('./features/reservation-manager/reservations-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.reservationManager.symbol,
      roles: Features.reservationManager.roles.user,
    },
  },
  {
    path: 'settings',
    loadChildren: () => import('./features/settings/settings-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.settings.symbol,
      roles: Features.settings.roles.admin,
    },
  },
  {
    path: 'stringer',
    loadChildren: () => import('./features/stringer/stringer-routing').then((m) => m.routes),
    canActivate: [AuthRoleGuard],
    data: {
      app: Features.stringer.symbol,
      roles: Features.stringer.roles.user,
    },
  },

  // ==========================================================================================================================
  //  routes not found
  // ==========================================================================================================================

  {
    path: '**',
    redirectTo: '/not-found'
  },
];
